import {BaseModel} from "../base";
import {BBModel} from "../../bb_model";
import {ClientQueueSet} from "../../collection/sets/client_queue_set";

class AdminClientQueueModel extends BaseModel {

    constructor(data) {
        super(data);
    }

    static $query(company) {
        return client_queue.query(company);
    }

    $update(data) {
        return this.$put('self', {}, data).then((res) => {
            ClientQueueSet.updateAll(this.self, this.company_id);
            this.constructor(res);
        });
    }

    $delete() {
        this.$flush('self');
        return this.$del('self').then((res) => {
            ClientQueueSet.delete(this.self, this.company_id);
        });
    }

    $refetch() {
        return new Promise((resolve, reject) => {
            this.$flush('self');
            this.$get('self').then((res) => {
                    this.constructor(res);
                    return resolve(this);
                }
                , err => reject(err));
        });
    }

    static $new(client_queue) {
        client_queue = new BBModel.Admin.ClientQueue(client_queue);
        return client_queue;
    }
}

export {
    AdminClientQueueModel
}